import { createAction, props } from '@ngrx/store';

export const mobileEnter = createAction('[Mobile] enter mobile view');
export const mobileLeave = createAction('[Mobile] leave mobile view');
export const mobileUpdate = createAction('[Mobile] update', props<{payload: any}>());

